import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { resumeTask } from "./api";
import {
  handleTaskActionError,
  invalidateTaskViews,
} from "./invalidateTaskViews";

// Снятие паузы с задачи на её странице. Флаг паузы приходит в ответе
// задачи (task) и в кэше списка (tasks); task-events и queue — для
// единообразия с соседними хуками отмены и перезапуска. Инвалидация по
// смысловому префиксу матчит запись любого org-скоупа (см.
// `src/query/scope.ts`).
export function useResumeTask(
  taskId: string,
): ReturnType<typeof useMutation<void, Error, void>> {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation<void, Error, void>({
    mutationFn: () => resumeTask(taskId),
    onSuccess: () => {
      invalidateTaskViews(queryClient, taskId);
    },
    onError: (error) => {
      handleTaskActionError(queryClient, taskId, error, t);
    },
  });
}
